import { BookingInquiryProfit } from '@models/next/BookingInquiryProfit';

export class BookingInquiryProfitHelper {
  constructor(public data: BookingInquiryProfit) {}

  get sales() {
    return this.data.invoice?.tax_excluded_total_price;
  }

  get grossProfit() {
    const sales = this.data.invoice?.tax_excluded_total_price;
    const cost = this.data.payment?.tax_excluded_total_price;
    if (sales == null || cost == null) {
      return undefined;
    } else {
      return sales - cost;
    }
  }
}
